var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationMarkerPublicChargerSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28,12c0-6.6171875-5.3828125-12-12-12S4,5.3828125,4,12c0,3.8837891,2.9150391,8.6748047,4.1679688,10.5546875 L13.1315308,30H10v2h12v-2h-3.1315308l4.963562-7.4453125C25.0849609,20.6748047,28,15.8837891,28,12z M16.7226562,29.6132812 c-0.3222656,0.484375-1.1230469,0.484375-1.4453125,0l-5.4453125-8.1679688C7.4326172,17.8457031,6,14.3154297,6,12 C6,6.4863281,10.4863281,2,16,2s10,4.4863281,10,10c0,2.3154297-1.4326172,5.8457031-3.8320312,9.4453125L16.7226562,29.6132812z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,12h-4.1318359l2.9638672-4.4453125l-1.6640625-1.109375l-4,6 c-0.2041016,0.3066406-0.2236328,0.7011719-0.0498047,1.0263672S12.6308594,14,13,14h4.1318359l-2.9638672,4.4453125 l1.6640625,1.109375l4-6c0.2041016-0.3066406,0.2236328-0.7011719,0.0498047-1.0263672S19.3691406,12,19,12z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerPublicChargerSmall);
export default __webpack_public_path__ + "static/media/location-marker-public-charger--small.a4992d4b43b3fa8af5c85b086a067ae0.svg";
export { ForwardRef as ReactComponent };